module.exports = __webpack_public_path__ + "img/lightbulb-04.7da63687.svg";